import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NavigationEnd, Router, RouterModule } from '@angular/router'
import { EluxIcon, EluxSwitch } from '@elxjs/ui'
import { MENU_PERMISSION_SECTIONS, Permission } from '@models'
import { AuthService } from '@services'
import { environment } from '@env'

interface MenuItem {
  name: string
  icon: string
  link: string
  isActive: boolean
  isOpen: boolean
  subMenus: SubmenuItem[]
}

interface SubmenuItem {
  name: string
  link: string
}

@Component({
  standalone: true,
  selector: 'app-menu',
  imports: [CommonModule, RouterModule, EluxSwitch, EluxIcon],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  isExpanded: boolean = false
  fixed: boolean = localStorage.getItem('menu_fixed') === null ? false : localStorage.getItem('menu_fixed') === 'true'

  menuItems: MenuItem[] = []

  envName: string = environment.environment

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.setMenus()

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) this.setActiveMenu()
    })
  }

  async setMenus() {
    const userInfo = this.authService.getUserInfo()
    const tenantActive = await this.authService.getTenantActive()
    const roles = userInfo?.Tenants.find((tenant) => tenant.Id == tenantActive?.id)?.Roles ?? []

    this.menuItems = MENU_PERMISSION_SECTIONS.filter((section) => section.key !== 'manage')
      .map((section) => {
        const items: Permission[] =
          section.items?.filter((sectionItem) => sectionItem.allowAccess || roles.includes(sectionItem.key)) ?? []

        return {
          name: section.name,
          icon: section.icon,
          link: section.key || '',
          isActive: false,
          isOpen: false,
          subMenus: items.map((item) => ({
            name: item.name,
            link: section.key ? section.key + '/' + item.key : '',
          })),
        }
      })
      .filter((section) => section.subMenus.length > 0)

    this.setActiveMenu()
  }

  setActiveMenu(): void {
    const currentUrl = this.router.url

    this.menuItems.forEach((menu) => {
      const isMainActive = currentUrl === menu.link
      const hasActiveChild = menu.subMenus?.some((sub) => currentUrl === sub.link)
      menu.isActive = isMainActive || hasActiveChild
    })
  }

  clickMenu(event: MouseEvent, item: MenuItem) {
    event.preventDefault()

    if (item.subMenus.length < 2) {
      this.router.navigate([item.subMenus[0].link])
    } else {
      item.isOpen = !item.isOpen
    }
  }

  onChange(check: boolean) {
    this.fixed = check
    localStorage.setItem('menu_fixed', this.fixed.toString())
  }
}
